import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-s-android-browser-menu",
  "use": "icon-s-android-browser-menu-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22 22\" id=\"icon-s-android-browser-menu\"><path d=\"M10.75 22a2.75 2.75 0 1 0 0-5.5 2.75 2.75 0 0 0 0 5.5m0-8.25a2.75 2.75 0 1 0 0-5.5 2.75 2.75 0 0 0 0 5.5m0-8.25a2.75 2.75 0 1 0 0-5.5 2.75 2.75 0 0 0 0 5.5\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol